import { DecorItemI, OriginDecorI } from "../shared";

type WorkbenchToolboxSpec = {
    width: number;
    height: number;
    depth: number;
    model?: string;
};

const WORKBENCH_TOOLBOX_SPECS: Record<string, WorkbenchToolboxSpec> = {
    "15707": {
        width: 1.205,
        height: 1.04,
        depth: 0.755,
        model: "/models/workbench-toolbox-1200.glb",
    },
    "15708": {
        width: 1.505,
        height: 1.04,
        depth: 0.755,
    },
    "15709": {
        width: 1.805,
        height: 1.04,
        depth: 0.755,
    },
};

type WorkbenchToolboxIdentity = {
    ID?: string;
    bitrixId?: string;
    modelId?: string;
};

const getWorkbenchToolboxId = (item: WorkbenchToolboxIdentity) => item.bitrixId || item.modelId || item.ID;

export const getWorkbenchToolboxSpec = (item: WorkbenchToolboxIdentity) => {
    const id = getWorkbenchToolboxId(item);
    return id ? WORKBENCH_TOOLBOX_SPECS[id] : undefined;
};

export const requiresPreciseWorkbenchToolboxBounds = (item: WorkbenchToolboxIdentity) =>
    Boolean(getWorkbenchToolboxSpec(item));

export const normalizeWorkbenchToolboxOriginDecor = (decor: OriginDecorI): OriginDecorI => {
    const spec = getWorkbenchToolboxSpec(decor);

    if (!spec?.model) {
        return decor;
    }

    return {
        ...decor,
        PROPERTIES: {
            ...decor.PROPERTIES,
            FILE_3D: `${process.env.PUBLIC_URL || ""}${spec.model}`,
        },
    };
};

export const normalizeWorkbenchToolboxDecor = (decor: DecorItemI): DecorItemI => {
    const spec = getWorkbenchToolboxSpec(decor);

    if (!spec) {
        return decor;
    }

    const position: DecorItemI["position"] = [...decor.position];
    const translate: DecorItemI["translate"] = [...decor.translate];

    if (decor.initialized && decor.surface === "floor") {
        const heightOffset = (spec.height - decor.height) / 2;
        position[1] += heightOffset;
        translate[1] += heightOffset;
    }

    return {
        ...decor,
        width: spec.width,
        height: spec.height,
        depth: spec.depth,
        position,
        translate,
    };
};
